import type { BillDetailPageTab } from '@omnea-app/fe-routing/routes/detailTabs'

export const getBillDetailPath = (billId: string, tab?: BillDetailPageTab) =>
  tab == null ? `/bills/detail/${billId}` : `/bills/detail/${billId}/${tab}`
